import { ConfigurationDto2 } from '@/api-sdk';
import { FgConfiguration } from '@/components';
import { Mode, Variant } from '@/types';
import { createContext } from '@lit/context';

/**
 * Interface for the configuration context.
 */
export interface ConfigurationContextType {
  /** The ID of the configuration. */
  configurationId: string;
  /** Indicates if the configuration is configurable. */
  configurable: boolean;
  /** Indicates if the configuration is deletable. */
  deletable: boolean;
  /** Indicates if the configuration is personalizable. */
  personalizable: boolean;
  /** Indicates if the print proof button should be shown. */
  showPrintProofButton: boolean;
  /** Indicates if the configuration details should be shown. This property is set in CE-FE.
   * In the order detail page and added to cart modal this property is set to false, so the configuration details are not shown.
   * In the checkout this property is set to true when cart qty === 1 */
  showConfigurationDetails: boolean;
  /** Indicates if the toggle for configuration details should be hidden. */
  hideConfigurationDetailsToggle: boolean;
  /** Indicates if the modal is inset. This property is currently used to add or remove the actions.
   * For example in the cart modal the actions are hidden modalInset is set to true. */
  modalInset: boolean;
  /** Indicates if the totals should be removed. */
  removeTotals: boolean;
  /** The URL of the logo. */
  logoUrl: string;
  /** The store code (optional). */
  storeCode?: string;
  /** Indicates if the stock should be validated. */
  validateStock: 0 | 1 | undefined;
  /** The mode of the configuration. This can be default, digital example or quote */
  mode: Mode;
  variant?: Variant;
  hideConfigurationSummary?: boolean;
  configurationData: ConfigurationDto2;
}

export const GlobalConfigurationContext =
  createContext<ConfigurationContextType>(Symbol('ConfigurationContext'));

export const initConfigurationContext = (
  element: FgConfiguration,
): ConfigurationContextType => {
  return {
    configurationId: element.configuration || '',
    configurable: element.configurable,
    deletable: element.deletable,
    personalizable: element.personalizable,
    showPrintProofButton: element.showPrintProofButton,
    showConfigurationDetails: element.showConfigurationDetails,
    hideConfigurationDetailsToggle: element.hideConfigurationDetailsToggle,
    modalInset: element.modalInset,
    removeTotals: element.removeTotals,
    logoUrl: element.logoUrl,
    storeCode: element.storeCode,
    validateStock: element.validateStock,
    mode: element.mode,
    variant: element.variant,
    configurationData: element.configurationData,
    hideConfigurationSummary: element.hideConfigurationSummary,
  };
};
